import React, { useState, Fragment } from 'react'
import { Combobox, Transition } from '@headlessui/react'

const AutocompleteDeliveryAddress = ({ data = [], onSelect, placeholder = 'Search saved addresses' }) => {
  const [query, setQuery] = useState('')

  const norm = (s) => (s || '').toString().toLowerCase().replace(/\s+/g, '')
  const filtered = query === ''
    ? data
    : data.filter((row) => {
        const hay = [row.deliveryCompanyName, row.deliveryName, row.deliveryPincode, row.deliveryCity, row.deliveryAddress]
        return hay.some(v => norm(v).includes(norm(query)))
      })

  return (
    <div className="">
      <Combobox value={null} onChange={(val) => onSelect && onSelect(val)}>
        <div className="relative mt-1">
          <div className="relative w-full px-3 text-[.8rem] border-[1px] border-gray-500 py-[.6rem] cursor-default overflow-hidden rounded-lg bg-white text-left focus:outline-none">
            <Combobox.Input
              className="w-full capitalize text-[16px] placeholder:text-[#959595] border-none outline-none leading-5 text-gray-900 focus:ring-0"
              displayValue={() => ''}
              placeholder={placeholder}
              onChange={(event) => setQuery(event.target.value)}
            />
          </div>
          <Transition as={Fragment} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0" afterLeave={() => setQuery('')}>
            <Combobox.Options className="absolute mt-1 z-[999] capitalize max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
              {filtered?.length === 0 && query !== '' ? (
                <div className="relative cursor-default select-none px-4 py-2 text-gray-700">Nothing found.</div>
              ) : (
                filtered?.map((row, idx) => (
                  <Combobox.Option
                    key={idx}
                    className={({ active }) => `relative cursor-default select-none py-2 pl-3 pr-4 ${active ? 'bg-[#1081E0] text-white' : 'text-gray-900'}`}
                    value={row}
                  >
                    <div className="text-[0.85rem]">
                      <div className="font-medium">{row.deliveryCompanyName || row.deliveryName}</div>
                      <div className="text-[0.75rem] opacity-80">
                        {row.deliveryAddress}, {row.deliveryCity}, {row.deliveryState} - {row.deliveryPincode}
                      </div>
                      {row.deliveryPhone && <div className="text-[0.75rem] opacity-80">{row.deliveryPhone}</div>}
                    </div>
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </div>
  )
}

export default AutocompleteDeliveryAddress

